import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { Input } from '@salesforce/design-system-react';

export const ShortText = ({ enabled, required, label, fieldName, handleChange, error, defaultValue }) => {
  const [shortText, setShortText] = useState('');

  useEffect(() => {
    setShortText(defaultValue);
  }, [defaultValue]);

  return (
    <div className='time-shorttext input-text'>
      <Input
        type='text'
        label={label}
        disabled={!enabled}
        required={required}
        maxLength={'18'}
        name={fieldName}
        errorText={error}
        value={shortText}
        onChange={(event) => {
          setShortText(event.target.value);
          handleChange(event, { fieldName, value: event.target.value });
        }}
      />
    </div>
  );
};

ShortText.propTypes = {
  enabled: PropTypes.bool,
  required: PropTypes.bool,
  label: PropTypes.string,
  fieldName: PropTypes.string,
  handleChange: PropTypes.func,
  error: PropTypes.string,
  defaultValue: PropTypes.string,
};
